import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CouponPoolCreateComponent } from '../coupon-pool-create/coupon-pool-create.component';
import { ApiCallService } from 'src/app/core/services/api-call-service';
import { SnackbarCollection } from 'src/app/core/services/snackbar.service';
import { TranslateDynamicText } from 'src/app/shared/pipes/dynamic-translation.pipe';
import { MatPaginator } from '@angular/material/paginator';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { CouponPoolExportComponent } from '../coupon-pool-export/coupon-pool-export.component';
import { ExportEventService } from '../../service/export-event.service';
import { getdateformatService } from 'src/app/core/services/get-date-format.service';
import { Globals } from 'src/app/core/services/global.service';

@Component({
  selector: 'app-coupon-listing',
  templateUrl: './coupon-listing.component.html',
  styleUrls: ['./coupon-listing.component.css', '../badge-listing/badge-listing.component.css']
})
export class CouponListingComponent implements OnInit {

  constructor(private dialog:MatDialog,
    private _apicall:ApiCallService,
    private _snackBar:SnackbarCollection,
    private _i18nDynamicTranslate:TranslateDynamicText,
    private exportEventService: ExportEventService,
    private date_format: getdateformatService,
    private global: Globals,
    )  { }

  @ViewChild("paginator") paginator: MatPaginator;

  
  ngOnInit(): void {
    this.exportEventService.exportCompleted$.subscribe(() => {
      this.loadCouponPoolList(); // 👈 Called when file download is done
    });
    this.loadData();
  }

  getDateFormat(type?){
    return this.date_format.getDateFormat(type);
  }

  openCreateDialog(mode,coupon) {

    let data :any = {
      mode:'create',
    }
    if(mode == 'editCoupon') {
      data = {
        couponPoolId:coupon.couponPoolId,
        couponCode:coupon.code,
        couponId:coupon.id,
        mode:mode,
        hasSpecialConfig:coupon.couponOfferId||coupon.couponGiftCodeId,
        hasEditLock:coupon.isRedeemed,
      }
      if(coupon.poolOfferId || coupon.poolGiftCodeId) {
        data['offerId'] = coupon.poolOfferId;
        data['giftCodeId'] = coupon.poolGiftCodeId;
      }
      //if coupon has special config, then we need to pass the offerId and giftCodeId
      if(coupon.couponOfferId || coupon.couponGiftCodeId) {
        data['offerId'] = coupon.couponOfferId;
        data['giftCodeId'] = coupon.couponGiftCodeId;
      }
    }
    if(mode == 'editPool') {
      data = {
        couponPoolId:coupon.couponPoolId,
        offerId:coupon.poolOfferId,
        giftCodeId:coupon.poolGiftCodeId,
        mode:mode,
      }
    }
    const dialogRef = this.dialog.open(CouponPoolCreateComponent, { 
      width: '80vw',
      height: '90vh',
      data: data,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.action == 'refreshList') {
        this.refreshData();
      }
      if(result && result.action == 'refreshCouponPoolList') {
        this.loadCouponPoolList();
      }
    });
  }

  openExportDialog() {
    const dialogRef = this.dialog.open(CouponPoolExportComponent, { 
      width: '455px',
      height: '260px',
      data: {
        couponPoolList: this.couponPoolList,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result && result.action == 'refreshCouponPoolList') {
        this.loadCouponPoolList();
      }
    });
  }

  couponPoolList = [];
  couponList = [];
  listSearch='';
  paginationConfig = {
    total: 0,
    pageIndex: 0,
    pageSize: 10,
  }
  isDataLoading = false;
  couponPoolBeingExportedName = null;
  couponPoolBeingPopulatedName = null;
  loadData() {
    this.isDataLoading = true;
    this._apicall.getPaginatedCouponsByMerchantId(this.paginationConfig.pageIndex,this.paginationConfig.pageSize,null,this.listSearch,this.filters).subscribe(
      response => {
          // this.resetSearchAndPagination();
          this.couponList = response["body"]['coupons'];
          this.paginationConfig.total = response["body"]['totalCoupons'];
          this.isDataLoading = false;
      },
      error => {
        this.isDataLoading = false;
        this._snackBar.openSnackBar(error.error, 4000);
      }
    );
    this.loadCouponPoolList();
  }

  loadCouponPoolList() {
    this._apicall.getCouponPoolsByMerchantId().subscribe(
      response => {
        this.couponPoolList = response["body"];
        this.couponPoolBeingExportedName = null;
        this.couponPoolBeingPopulatedName = null;
        if(this.couponPoolList.length > 0) {
          for(let i=0;i<this.couponPoolList.length;i++) {
            if(this.couponPoolList[i].isExporting) {
              this.couponPoolBeingExportedName =  this.couponPoolList[i].name;
            }
            if(this.couponPoolList[i].isPopulating) {
              this.couponPoolBeingPopulatedName = this.couponPoolList[i].name
            }
          }
        }
      },
      error => {
        this._snackBar.openSnackBar(error.error, 4000);
      }
    );
  }

  clearSearch() {
    this.listSearch = null,
    this.resetPaginationData();
    this.loadData();
  }

  timeout
  onKeySearch(event: any) {
    clearTimeout(this.timeout);
    var $this = this;
    this.timeout = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.resetPaginationData();
        $this.loadData();
      }
    }, 600);
  }

  refreshPaginatedData(event) {
    this.paginationConfig.pageSize = event.pageSize;
    this.paginationConfig.pageIndex = event.pageIndex;
    this.loadData();
  }

  resetPaginationData() {
    this.paginationConfig.total = 0;
    this.paginationConfig.pageIndex = 0;
    // this.abTestingCampaignListPaginationConfig.recordsPerPage = 10;
    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  refreshData() {
    this.resetPaginationData();
    this.listSearch = null;
    this.filters = {
      couponPool: [],
      isRedeemed: null,
    };
    this.loadData();
  }

  filters = {
    couponPool: [],
    isRedeemed: null,
  };
  filtersBackup = {
    couponPool: [],
    isRedeemed: null,
  };
  showFiltersDiv = false;
  couponPoolFilterSearch = '';
  openFiltersDiv() {
    this.showFiltersDiv = true;
    this.couponPoolFilterSearch = '';
    this.getFilteredCouponPools();
  }

  getFilteredCouponPools() {
    return this.couponPoolList.filter((couponPool) => couponPool.name.toLowerCase().includes(this.couponPoolFilterSearch.toLowerCase()));
  }

  showClearAll = false;
  addSegmentFilter(value,segmentType?) {
    if (this.filters[segmentType].indexOf(value) != -1) {
      this.filters[segmentType].splice(this.filters[segmentType].indexOf(value),1);
      // if (this.filters[segmentType].indexOf("ALL") != -1 && value !== "ALL") {
      //   this.filters[segmentType].splice(this.filters[segmentType].indexOf("ALL"),1);
      // }
    } else {
      this.filters[segmentType].push(value);
    }
    
    if (this.filters[segmentType].length > 0) {
      this.showClearAll = true;
    } else {
      this.showClearAll = false;
    }
  }

  addRedemptionFilter(event,value) {
    if(event.checked) {
      this.filters["isRedeemed"] = value=='isRedeemed'? true : false;
    } else {
      this.filters["isRedeemed"] = null;
    }
  }

  closeFiltersDiv() {
    this.filters = JSON.parse(JSON.stringify(this.filtersBackup));;
    this.showFiltersDiv = false;
  }

  clear() {
    this.filters["couponPool"] = [];
    this.showClearAll = false;
  }

  applyFilter() {
    this.resetPaginationData();
    this.filtersBackup = JSON.parse(JSON.stringify(this.filters));
    this.loadData();
    this.closeFiltersDiv();
  }
  
  getCouponPoolName(id) {
    return this.couponPoolList.find((couponPool) => couponPool.id == id)?.name;
  }

  removeFilter(filter,id?) {
    if(filter == 'couponPool') {
      this.addSegmentFilter(id,filter);
    }
    if(filter == 'isRedeemed') {
      this.filters.isRedeemed = null;
    }

    if (this.filters['couponPool'].length > 0 || this.filters['isRedeemed'] || this.filters['isRedeemed'] == false) {
      this.showClearAll = true;
    } else {
      this.showClearAll = false;
    }
    this.applyFilter();
  }

  hasFilter() {
    return this.filters['couponPool'].length > 0 || this.filters['isRedeemed'] || this.filters['isRedeemed'] == false;
  }

  exportCouponPoolInCSV(couponPoolId,isCsv) {
    this._apicall.exportCouponPool(couponPoolId,isCsv).subscribe(
      (response) => {
        const blob = new Blob([response], { type: 'application/octet-stream' }); // Change type based on your file
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'exported_file.zip'; // Change the filename as needed
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      (error) => {
        this._snackBar.openSnackBar(error.error, 4000);
      }
    );
  }

  getDateInTimeZone(timestamp, format: 'time' | 'date'): string {
    return this.global.getDateInTimeZone2(timestamp, format);
  }

  // exportCouponPool2() {
  //   this._apicall.exportCouponPool2(1).subscribe((event: HttpEvent<Blob>) => {
  //     if (event.type === HttpEventType.DownloadProgress) {
  //       console.log(`Download progress: ${Math.round((event.loaded! / event.total!) * 100)}%`);
  //     } else if (event.type === HttpEventType.Response) {
  //       const blob = event.body!;
  //       const url = window.URL.createObjectURL(blob);
  //       const a = document.createElement('a');
  //       a.href = url;
  //       a.download = 'exported_file.zip';
  //       document.body.appendChild(a);
  //       a.click();
  //       document.body.removeChild(a);
  //       window.URL.revokeObjectURL(url);
  //     }
  //   });
  // }

}
